"use strict";
exports.__esModule = true;
exports.JavascriptExpressionParser = void 0;
var jsep_1 = require("./jsep");
var JavascriptExpressionParser = (function () {
    function JavascriptExpressionParser() {
    }
    JavascriptExpressionParser.prototype.parse = function (expression) {
        return (0, jsep_1.jsep)(expression);
    };
    return JavascriptExpressionParser;
}());
exports.JavascriptExpressionParser = JavascriptExpressionParser;
//# sourceMappingURL=parser.js.map